import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actionCreator from '../../redux/actions/data-action';
import { getTestTimeLimit } from '../assessment/common/task-utility';
import { ScreenContainer, ScreenNavigation } from './common';
import { Box, Button } from '@material-ui/core';
import { localDataExpiry } from '../../Constants';

class HomeScreen extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			hasTests: false,
			isLogout: false
		};

		this.onLogout = this.onLogout.bind(this);
		this.handleNext = this.handleNext.bind(this);
		this.getTest = this.getTest.bind(this);
	}

	componentDidMount() {
		const { history, resumeSession } = this.props;
		const resumeLocation = localStorage.getItem('resumeLocation');
		const resumeData = localStorage.getItem('resumeData');
		const resumeExpiry = parseInt(localStorage.getItem('resumeExpiry'));

		if (resumeLocation && resumeData) {
			if (resumeExpiry && new Date() > resumeExpiry) {
				localStorage.clear();
			} else {
				resumeSession(JSON.parse(resumeData));
				history.push(resumeLocation);
			}
		}

		this.test = this.getTest();
	}

	componentWillUnmount() {
		if (this.state.isLogout) {
			this.props.clearUserData();
		}
	}

	onLogout() {
		const { logToSentry } = this.props;

		logToSentry('info', 'User Logout');
		this.setState({isLogout: true}, () => this.props.history.push('/Login'));
	}

	handleNext() {
		const { history, data, getAllData } = this.props;
		const { inviteId, sessionID, userData } = data;
		const versionId = parseInt(this.test.value);
		const participantId = userData.username;

		this.setState({isLoading: true});

		getAllData(
			{ versionId, inviteId, participantId, sessionID },
			res => {
				if (!!res.resumeURL) {
					const timeLimit = getTestTimeLimit(data.userData.grade) * 60;
					localStorage.setItem('resumeLocation', res.resumeURL);
					localStorage.setItem('resumeData', JSON.stringify(res));
					localStorage.setItem('resumeExpiry', new Date() + localDataExpiry);
					localStorage.setItem('resumeTime', res.timeRemaining === null ? 0 : (timeLimit - res.timeRemaining));
					history.push(res.resumeURL);
				} else {
					history.push('/Demographic');
				}
			},
			err => this.setState({isLoading: false})
		);
	}

	getTest() {
		const { tests } = this.props;

		const filteredTests = Object.values(tests)
			.filter(test => test.sortOrder !== 0 && test.isCompleted === 0)
			.sort((a, b) => (a.sortOrder - b.sortOrder))
			.map(test => ({
				text: test.displayName,
				value: test.versionNum
			}));

		if (!filteredTests.length) {
			this.setState({hasTests: false});
			return null;
		}

		this.setState({hasTests: true});
		return filteredTests[0];
	}

	render() {
		const { hasTests, isLoading } = this.state;
		const label = hasTests ? this.test.text : 'All tests completed.';

		return (
			<ScreenContainer>
				<Box className="home-header">
					<Button className="logout-button" onClick={this.onLogout}>LOGOUT</Button>
				</Box>
				<Box className="home-form">
					<div className="test-label">
						{isLoading ? 'Loading...' : label}
					</div>
				</Box>
				<ScreenNavigation type="next" onClick={this.handleNext} isVisible={hasTests && !isLoading} />
			</ScreenContainer>
		);
	}
}

const mapStateToProps = state => ({
	data: state.data,
	tests: state.data.userData.tests
});

export default connect(mapStateToProps, actionCreator)(HomeScreen);
